import { BrighterionAuthService } from '@brighterion/br-auth-service';

type GetAccessTokenProps = {
    authService: BrighterionAuthService;
    refresh?: boolean;
};

export const getAccessToken = async ({ authService, refresh }: GetAccessTokenProps): Promise<string> => {
    if (refresh) {
        await authService.refreshAccessToken();
    }
    const accessToken = await authService.getAccessToken();
    if (!accessToken) {
        throw new Error('Invalid Access Token');
    }
    return accessToken;
};
